import axios from 'axios'
const RESOURCE_NAME_GET_NAV_MESSAGES = '/api/config/GetNavMessages'

export const ConfigService = {
    GetNavMessages
};

function GetNavMessages(cb, errorCb) {
    axios
        .get(RESOURCE_NAME_GET_NAV_MESSAGES 
        )
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}
